export const track = (event, data = {}) => {
  if (typeof window === "undefined") return;
  window.dataLayer = window.dataLayer || [];
  window.dataLayer.push({ event, ...data });
};

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;
let configPromise = null;
export const loadPublicConfig = () => {
  if (!configPromise) {
    configPromise = fetch(`${API}/public/config`)
      .then((r) => (r.ok ? r.json() : {}))
      .catch(() => ({}));
  }
  return configPromise;
};

export const formatPhone = (digits) =>
  digits && digits.startsWith("994") && digits.length === 12
    ? `+994 ${digits.slice(3, 5)} ${digits.slice(5, 8)} ${digits.slice(8, 10)} ${digits.slice(10)}`
    : `+${digits}`;
